export const IPIFY_API = 'https://api.ipify.org?format=text&callback=getIP';
